<template>
  <div :class="dynamicClasses">    
    <span v-for="filter in this.data" :key="filter.oid" :separator="false" class="ml-2 mr-2">
      <nna-button-filter @click.native="onFilter(filter)">{{filter.name}}</nna-button-filter>
    </span>    
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'
export default {
  name: 'productsFilter',
  props: [
    'data',
  ],
  components: {
  },
  data() {
    return {
      filterSelected: []
    }
  },
  computed: {
    ...mapGetters({
      productsfilterSelected: 'shops/productsfilterSelected'
    }),
    dynamicClasses() {
      return {
        
      }        
    },
  },
  methods: {
    ...mapActions({
    }),
    onFilter(filter) {
      let isSelected = _.some(this.filterSelected, item => item.name === filter.name)      
      if(isSelected) {
       _.map(this.filterSelected, (item) => {
            if(item.name === filter.name) {
              item.visible = !item.visible
            }            
            return item
        });
        this.$store.commit("shops/PRODUCTS_UPDATE_FILTER_SELECTED", this.filterSelected)
      } else {
        this.$store.commit("shops/PRODUCTS_UPDATE_FILTER_SELECTED", this.filterSelected.push({ name: filter.name, visible: true }))
      }      
      this.$emit('onFilter', this.filterSelected)
    }
  },
  mounted() {
    this.filterSelected = this.productsfilterSelected
  },
  beforeDestroy() {
    this.$store.commit("shops/PRODUCTS_FILTER_CLEAN")
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/modules/common/components/products/productsFilter.vue